/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DragonTribeGameAssets} from "../DragonTribeGameAssets";
import {DTReelSymbol} from "./DTReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {DragonTribeGameConfig} from "../DragonTribeGameConfig";
import {TweenLite} from "gsap";

export class DTReelSymbolM extends DTReelSymbol {
    protected static symbolBgTintColor:{ [symName:string]:number } = {
        "M1" : 0xff2323,
        "M2" : 0xffa800,
        "M3" : 0xaae41f,
        "M4" : 0x1fa36a,
        "M5" : 0x35e5df,
        "M6" : 0x5867a9
    };

    protected static _innerMaskOffset:number = 4;
    private _innerMask:PIXI.Graphics | null;
    private _wildPatchAnimation:TimelineSprite;
    private _isWild:boolean = false;

    public set isWild(isWild:boolean) {
        this._isWild = isWild;
        if(isWild) {
            this.showWildPatch();
        } else {
            this.removePatch();
        }
    }

    public get isWild():boolean {
        return this._isWild;
    }

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    public set symHeight(value:number) {
        if(value === this._symHeight) {
            return;
        }
        this._symHeight = value;
        this.updateBackground(value);
        this.resetSymMask();
        this.drawSymMask();
        this.updateWildText(value);
    }

    public get symHeight():number {
        if(this._symHeight == null) {
            return GameConfig.instance.SYMBOL_HEIGHT;
        }
        return this._symHeight;
    }

    protected initAnimations():void {
        super.initAnimations();
        if(!this._wildPatchAnimation) {
            this._wildPatchAnimation = new TimelineSprite(GameResources.getTextures("M_wild_text"));
            this._wildPatchAnimation.anchor.set(0.5, 0.5);
            this._wildPatchAnimation.position.set(0, 0);
            this._wildPatchAnimation.hide();
        }
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            if(this.isWild && this._wildPatchAnimation) {
                this.addChild(this._wildPatchAnimation);
            }
            if(this._innerMask) {
                this._stateAnimations[stateConfig.keyword]!.mask = this._innerMask;
            }

            return true;
        }

        return false;
    }

    protected resetSymMask():void {
        super.resetSymMask();

        if(this._innerMask) {
            for(let stateName in this._stateAnimations) {
                if(this._stateAnimations[stateName]) {
                    // TODO: #276
                    // this._stateAnimations[stateName]!.mask = null;
                }
            }
            this.removeChild(this._innerMask);
            this._innerMask = null;
        }
    }

    public updateBackground(symHeight:number,callFromAs:boolean=false):void {
        super.updateBackground(symHeight,callFromAs);
        this._symBackground.texture = GameResources.getTextures(DragonTribeGameAssets.M_BG)[0];
        this._symTop.texture = GameResources.getTextures(DragonTribeGameAssets.M_T)[0];
        this._symBottom.texture = GameResources.getTextures(DragonTribeGameAssets.M_B)[0];
        this._symSides.texture = GameResources.getTextures(DragonTribeGameAssets.M_S)[0];
        this._symBackground.tint =callFromAs?0xFFFFFF: DTReelSymbolM.symbolBgTintColor[this.symName];
    }

    protected drawSymMask():boolean {
        if(super.drawSymMask()) {
            if(this.symHeight < 255) {
                const offset:number = DTReelSymbolM._innerMaskOffset;
                this._innerMask = new PIXI.Graphics();
                this._innerMask.beginFill(0x00FF00, 1);
                this._innerMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2 - offset * 2, -this.symHeight / 2 + offset, GameConfig.instance.SYMBOL_WIDTH + 2 * offset, this.symHeight - offset * 2);
                this.addChild(this._innerMask);

                for(let stateName in this._stateAnimations) {
                    const state = this._stateAnimations[stateName];
                    if(state != null) {
                        state.mask = this._innerMask;
                    }
                }
            }
            return true;
        }
        return false;
    }

    public animateWildPatch(withAnimation:boolean):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        if(withAnimation) {
            timeline.add([
                () => {
                    this.addChild(this._wildPatchAnimation);
                },
                this._wildPatchAnimation.getAnimationAutoShowHide(true, false)
            ]);
        }
        timeline.add(() => {
            this.isWild = true;
        });
        return timeline;
    }

    private updateWildText(symHeight:number):void {
        if(this._wildPatchAnimation) {
            let posY:number = 0;
            if(symHeight < 110) {
                posY = (symHeight < 100) ? -20 : -6;
            }
            this._wildPatchAnimation.position.set(0, posY);
        }
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if(newState.state.keyword === DragonTribeGameConfig.instance.SYMBOL_STATES.win.keyword && (this._wildPatchAnimation && this._wildPatchAnimation.parent)) {
            const fs:number = 0.033;
            timeline.add(TweenLite.fromTo(this._wildPatchAnimation, 10 * fs, {alpha : 1}, {alpha : 0}), delay + 30 * fs);
            return;
        }
    }

    public showWildPatch():void {
        this._wildPatchAnimation.show();
        this.addChild(this._wildPatchAnimation);
        this._wildPatchAnimation.getAnimation([-1, -1]);
        this._symTop.texture = GameResources.getTextures("S_bg_top")[0];
        this._symBottom.texture = GameResources.getTextures("S_bg_bottom")[0];
        this._symSides.texture = GameResources.getTextures("S_bg_sides")[0];
    }

    public removePatch():void {
        if(this._wildPatchAnimation) {
            this._wildPatchAnimation.hide();
            this.removeChild(this._wildPatchAnimation);
        }

        if(this._symTop) {
            this._symTop.texture = GameResources.getTextures(DragonTribeGameAssets.M_T)[0];
        }

        if(this._symBottom) {
            this._symBottom.texture = GameResources.getTextures(DragonTribeGameAssets.M_B)[0];
        }

        if(this._symSides) {
            this._symSides.texture = GameResources.getTextures(DragonTribeGameAssets.M_S)[0];
        }
    }

    public onRemove():void {
        this.removePatch();
        super.onRemove();
    }
}